import { useEffect } from "react"

import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

import type { User } from "~/graphql/client"

import useSessionStorageState from "./useSessionStorage"

export const useRedirectUrl = (user: User): void => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()

  const [redirectUrl, setRedirectUrl, resetRedirectUrl] =
    useSessionStorageState<string>({
      key: `redirectUrl`,
      initialState: ``,
    })

  useEffect(() => {
    if (user.id && redirectUrl) {
      navigate(redirectUrl, { replace: true })
      resetRedirectUrl()
    }
    if (!user.id && !redirectUrl) {
      setRedirectUrl(
        pathname + (searchParams.toString() !== `` ? `?${searchParams}` : ``),
      )
    }
  }, [
    redirectUrl,
    setRedirectUrl,
    resetRedirectUrl,
    navigate,
    pathname,
    user.id,
    searchParams,
  ])
}
